module.exports = __webpack_public_path__ + "img/Romy Seidl.ffc38838.jpg";